var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4734_20020"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "notepad",
    rx: -0.5,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4734_20020)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2176",
    d: "M11 22L10.47 22C6.47 22 4.48 22 3.24 20.82C2 19.65 2 17.77 2 14L2 10C2 6.22 2 4.34 3.24 3.17C4.48 2 6.47 2 10.47 2L11.52 2C15.52 2 17.51 2 18.75 3.17C20 4.34 20 6.22 20 10L20 11",
    stroke: "#141B34",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4435",
    d: "M7 7L15 7",
    stroke: "#141B34",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4436",
    d: "M7 12L15 12",
    stroke: "#141B34",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.88 20.97C17.22 21.64 16.23 21.66 15.34 21.85C14.65 22 14.31 22.07 14.11 21.88C13.92 21.68 13.99 21.34 14.14 20.65C14.33 19.77 14.35 18.77 15.02 18.11L18.32 14.8C18.66 14.47 18.82 14.3 19 14.2C19.47 13.93 20.05 13.93 20.52 14.2C20.69 14.3 20.86 14.47 21.19 14.8C21.52 15.13 21.69 15.3 21.79 15.47C22.06 15.94 22.06 16.52 21.79 16.99C21.69 17.17 21.52 17.33 21.19 17.67L17.88 20.97Z",
    stroke: "#141B34",
    strokeOpacity: 1,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.60e9155b573541c8fa67d9d1794c24d2.svg";
export { ForwardRef as ReactComponent };